const substring = (value, amount) => {
    var trimmedString;
    if ( value && value !== null && value.length > 1) {
        var valueLength = value.length;
        if (valueLength > amount) {
            trimmedString = value.substring(0, amount) + '...';
        } else {
            trimmedString = value.substring(0, amount);
        }
        return trimmedString;
    }
}

export default substring;